import { render, staticRenderFns } from "./JoinedSidebarSection.vue?vue&type=template&id=1bb3357e&scoped=true&"
import script from "./JoinedSidebarSection.vue?vue&type=script&lang=js&"
export * from "./JoinedSidebarSection.vue?vue&type=script&lang=js&"
import style0 from "./JoinedSidebarSection.vue?vue&type=style&index=0&id=1bb3357e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb3357e",
  null
  
)

export default component.exports